module.exports = __webpack_public_path__ + "static/media/Industry-Medium.684d069b.ttf";